var map = {
	"./t1-1.jpg": "df06",
	"./t1-duo-1.jpg": "6df1",
	"./t2-1.jpg": "f791",
	"./t3-bronze.jpg": "7928",
	"./t3-gold.jpg": "b162",
	"./t3-silver.jpg": "c356"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf49";